<template>
  <div>
    <div class="tab-wrap">
      <jd-myTab
        :tabInfo="tabList"
        @switch="hugItemBtn"
      />
    </div>
    <flow-analysis-new v-show="topSelect == 1" ref="flowAnalysisNew"/>
    <div class="section-right-content-box" v-show="topSelect == 2">
      <div style="margin: 20px 0px 20px 0px">
        <el-form label-width="10px">
          <el-form-item>
            <span style="margin-right: 20px">统计时间 :</span>
            <el-radio
              v-model="queryForm.evaluateTime"
              @change="timeChange"
              v-for="item in options.evaluateTimeOpt"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="postForm.startDate"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div
                class="time_to_text"
                :class="{
                  to_text_disabled: queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
                }"
              >
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="postForm.endDate"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="true"
              ></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
            <el-button class="b1" style="margin-left: 20px" v-zoom="{ from: '忠诚度管理-数据分析-活动数据', name: '查询' }" @click="queryTotal()"
              ><span style="marginleft: 4px">
                <i
                  class="el-icon-search"
                  style="
                    display: inline-block;
                    width: 14px;
                    height: 12px;
                    fontweight: bold;
                    margin-right: 4px;
                  "
                ></i
                >查询</span
              ></el-button
            >
            <el-button class="b2" style="margin-left: 20px" @click="queryOne()"><span style="marginleft: 4px">重置</span></el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 下单转化 -->
      <div class="titClass">
        <div class="down">
          下单转化
          <el-popover placement="top-start" width="400" offset="100" trigger="hover" data-html="true">
            <span>转化数据说明：</span><br />
            <span> 1、人群:参与活动的用户。</span><br />
            <span> 2、时间:活动开始至T+1 (昨日)的累计成交数据，每天中午12:30后更新。</span><br />
            <span> 3、订单维度:已付款的在线支付订单或者选择货到付款的订单。</span><br />
            <span> 4、备注:活动结束后15天内的数据都可以统计，超过15天的数据将无法统计。</span><br />
            <span> 5、由于京东数据的限制，活动开始和结束时间只能以活动首次创建的时间为准;中途修改活动时间，无法更新转化数据的统计时间范围。</span
            ><br />
            <span style="float: right;" slot="reference">
              <p class="question_iconOne">?</p>
            </span>
          </el-popover>
        </div>
        <div class="borderU"></div>
        <div class="titClassOne" v-for="(v, index) in hostList" :key="index">
          <div style="color:#333333;font-size:14px;">
            {{ v.name }}
          </div>
          <div style="color:#333333;font-size:18px;font-weight:600;">
            {{ index == 0 ? tatal_num.users : index == 1 ? tatal_num.ordNum : index == 2 ? tatal_num.gmv : (Number(tatal_num.ordRate) * 100).toFixed(2) }}
            <span style="color:#999999;font-size:14px;">
              {{ index == 0 ? "人" : index == 1 ? "单" : index == 2 ? "元" : "%" }}
            </span>
          </div>
        </div>
      </div>

      <div class="background">
        <span class="title"></span>&nbsp;
        <span class="tips">数据总览</span>
      </div>
      <div v-loading="loading">
        <!-- <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">活动PV</span>
            <el-popover placement="top-start" width="200" offset="100" trigger="hover" content="活动页面访问次数，刷新一次或点击一次都算一次PV流量。">
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.activityPv }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">活动UV</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.activityUv }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">活动中心首页PV</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="会员中心首页访问次数，刷新一次或点击一次都算一次PV流量。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.pv }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">活动中心首页UV</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="会员中心首页页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.uv }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">参与人数</span>
            <el-popover placement="top-start" width="200" offset="100" trigger="hover" content="参与活动的人数。">
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.joinNumber }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">新增人数</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="参与活动的新增人数；以近7天为例，之前没有参与过活动，近七天参与过的新客户就属于新增人数。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.incrFollowNumber }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">参与次数</span>
            <el-popover placement="top-start" width="200" offset="100" trigger="hover" content="参与活动的次数。">
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.joinTimes }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">人均参与次数</span>
            <el-popover placement="top-start" width="200" offset="100" trigger="hover" content="参与次数/参与人数。">
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.perCapitaTimes }}</div>
        </div> -->
        <div class="overview1" style="float: left" v-for="(item, index) in dataSummary" :key="index + item.value">
          <div>
            <span class="fontClass">{{ item.name }}</span>
            <el-popover v-if="item.tipsName" placement="top-start" width="200" offset="100" trigger="hover" :content="item.tipsName">
              <span style="float: right; margin-top: -10px" slot="reference">
                <p class="question_icon">?</p>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ tableTotal[item.value] }}</div>
        </div>
      </div>

      <div style="clear: left" ref="payRemindChart" class="chart" v-loading="loading"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import echarts from "echarts";
import flowAnalysisNew from './flow_analysis_new'
import jdMyTab from '@/components/myTab'
import {
  getCouponData,
  getShopGiftParticipateConver,
  getChartEffectDetails,
  checkRecord,
} from "@/api/integralCenter/PointActivityAnalyticController";
export default {
  data() {
    return {
      dataSummary: [
        {
          value: "actPv", // 对应tableTotal的字段
          name: "活动PV",
          tips: true, // 提示的显示隐藏
          tipsName: "活动页面访问次数，刷新一次或点击一次都算一次PV流量。", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "actUv",
          name: "活动UV",
          tips: true,
          tipsName: "活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。",
          color: "#B2A8DA",
        },
        {
          value: "participateUv",
          name: "参与人数",
          tips: true,
          tipsName: "参与活动的人数。",
          color: "#F2D0B5",
        },
        {
          value: "participatePv",
          name: "参与次数",
          tips: true,
          tipsName: "参与活动的次数。",
          color: "#F4ACB9",
        },
        {
          value: "participateAvg",
          name: "人均参与次数",
          tips: true,
          tipsName: "参与次数/参与人数。",
          color: "#C2CDDE",
        },
        {
          value: "shareUv",
          name: "分享人数",
          tips: false,
          tipsName: "",
          color: "#A7878E",
        },
        {
          value: "sharePv",
          name: "分享次数",
          tips: false,
          tipsName: "",
          color: "#B8C7F3",
        },
        {
          value: "scanshopUv",
          name: "浏览店铺人数",
          tips: false,
          tipsName: "",
          color: "#CAC7A1",
        },
        {
          value: "scanshopPv",
          name: "浏览店铺次数",
          tips: false,
          tipsName: "",
          color: "#E57733",
        },
        {
          value: "cartUv",
          name: "加购人数",
          tips: false,
          tipsName: "",
          color: "#D39595",
        },
        {
          value: "cartPv",
          name: "加购次数",
          tips: false,
          tipsName: "",
          color: "#C2D1C8",
        },
        {
          value: "followshopUv",
          name: "新增粉丝人数",
          tips: false,
          tipsName: "",
          color: "#BB7495",
        },
        {
          value: "followshopPv",
          name: "新增粉丝次数",
          tips: false,
          tipsName: "",
          color: "#96AA08",
        },
        {
          value: "followskuUv",
          name: "新增商品关注人数",
          tips: false,
          tipsName: "",
          color: "#77B2BD",
        },
        {
          value: "followskuPv",
          name: "新增商品关注次数",
          tips: false,
          tipsName: "",
          color: "#D6BF50",
        },
        // {
        //   value: "redbagkuPv",
        //   name: "积分兑换红包",
        //   tips: false,
        //   tipsName: "",
        //   color: "#7b61ff",
        // },
      ],
      hostList: [
        {
          name: "下单用户量",
          nameOne: 100,
        },
        {
          name: "下单订单总量",
          nameOne: 100,
        },
        {
          name: "下单金额",
          nameOne: 100,
        },
        {
          name: "下单转化率",
          nameOne: 100,
        },
      ],
      tatal_num: {
        users: 0, //活动参与用户15天内下单用户量
        ordNum: 0, //活动参与⽤户15天内下单订单总量
        gmv: 0, //活动参与⽤户15天内下单转化金额(元)
        ordRate: 0, //活动参与⽤户15天内下单转化率
      },
      messageOne: "流量分析",
      messageTwo: "活动数据",
      messageThree: "奖品统计",
      topSelect: 1,
      tabActiveIndex: 1,
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      //折线图数据
      myCharts: null,
      tableTotal: {},
      chartEffectDetail: {
        homePagePv: [], //会员中心首页PV
        homePageUv: [], //会员中心首页uv
        incrJoinNumber: [], //参与人数今日增量
        joinNumber: [], //参与人数
        joinTimes: [], //参与人次
        perCapitaTimes: [], //人均参与次数
        pv: [], //页面浏览数
        statsDate: [], // 统计日期
        uv: [], //页面访问人数
      },

      queryForm: {
        evaluateTime: "30",
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      countTable: [],
      loading: true,
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "15",
            label: "近15天",
          },
          {
            value: "30",
            label: "近30天",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      tabList: [
        {
          label: "活动数据(新)",
          value: 1,
        },
        {
          label: "活动数据(旧)",
          value: 2,
        },
      ]
    };
  },
  components:{
    flowAnalysisNew,
    jdMyTab
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  created() {
    this.timeChange(30);
    this.queryTotal();
  },
  mounted() {
    // this.nextTick();
  },
  methods: {
    hugItemBtn(type) {
      this.topSelect = type;
      if(type == 1){
        this.$nextTick(()=>{
          this.$refs.flowAnalysisNew.uploadChart()
        })
      }else{
        this.$nextTick(()=>{
          this.myCharts && this.myCharts.resize();
        })
      }
    },
    //查询数据总和
    async queryTotal() {
      this.loading = true;
      //下单转化数据
      getShopGiftParticipateConver({ startTime: this.postForm.startDate, endTime: this.postForm.endDate }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.tatal_num = res.data;
        } else {
          this.tatal_num = {
            gmv: 0,
            newShopGmv: 0,
            newShopUsers: 0,
            ordNum: 0,
            ordRate: 0,
            users: 0,
          };
        }
      });
      // 活动pv
      getCouponData({
        startTime: this.postForm.startDate,
        endTime: this.postForm.endDate,
      })
        .then((res) => {
          this.loading = false;
          this.tableTotal = res.data;
          console.log(res);
        })
        .catch((res) => {
          this.$message.error("输入时间错误");
        });

      //折线图数据查询
      const { data: dataList } = await checkRecord({ startTime: this.postForm.startDate, endTime: this.postForm.endDate });
      if (dataList.length == 1 && dataList.length == 0) {
        this.$message.error("折线图时间过短");
      } else {
        this.chartEffectDetail = dataList;
        this.$nextTick(() => {
          this.initChart();
          window.addEventListener("resize", () => {
            this.myCharts.resize();
          });
        });
      }
      //折线图数据查询
      // getChartEffectDetails({
      //   startTime: this.postForm.startDate,
      //   endTime: this.postForm.endDate,
      // })
      //   .then((res) => {
      //     if (res.data.length == 1 && res.data.length == 0) {
      //       this.$message.error("折线图时间过短");
      //     } else if (res.data.length > 1) {
      //       var dataList = res.data;
      //       // console.log(dataList);
      //       var homePagePvList = []; //活动中心首页PV
      //       var homePageUvList = []; //活动中心首页uv
      //       var incrJoinNumberList = []; //新增人数
      //       var joinNumberList = []; //参与人数
      //       var joinTimesList = []; //参与人次
      //       var perCapitaTimesList = []; //人均参与次数
      //       var pvList = []; //pv
      //       var statsDateList = []; // 统计日期
      //       var uvList = []; //uv
      //       dataList.forEach((item) => {
      //         homePagePvList.push(item.pv);
      //         homePageUvList.push(item.uv);
      //         incrJoinNumberList.push(item.newAddNumber);
      //         joinNumberList.push(item.joinNumber);
      //         joinTimesList.push(item.joinTimes);
      //         perCapitaTimesList.push(item.perCapitaTimes);
      //         pvList.push(item.activityPv);
      //         statsDateList.push(item.statsDate);
      //         uvList.push(item.activityUv);
      //       });
      //       this.chartEffectDetail = {
      //         pv: homePagePvList, //会员中心首页PV
      //         uv: homePageUvList, //会员中心首页uv
      //         newAddNumber: incrJoinNumberList, //参与人数今日增量
      //         joinNumber: joinNumberList, //参与人数
      //         joinTimes: joinTimesList, //参与人次
      //         perCapitaTimes: perCapitaTimesList, //人均参与次数
      //         activityPv: pvList, //页面浏览数
      //         statsDate: statsDateList, // 统计日期
      //         activityUv: uvList, //页面访问人数
      //       };
      //     }
      //     this.$nextTick(() => {
      //       this.initChart();
      //       window.addEventListener("resize", () => {
      //         this.myCharts.resize();
      //       });
      //     });
      //   })
      //   .catch((res) => {
      //     this.$message.error("输入时间错误");
      //   });
    },
    //折线图
    initChart() {
      this.myCharts = echarts.init(this.$refs.payRemindChart);
      this.setOptions();
    },
    //折线图事件
    setOptions() {
      const seriesList = this.dataSummary.map((item) => {
        return {
          name: item.name,
          type: "line",
          smooth: true,
          color: item.color,
          data: this.chartEffectDetail.map((i) => i[item.value]),
        };
      });
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // data: ["活动PV", "活动UV", "活动中心首页PV", "活动中心首页UV", "参与人数", "新增人数", "参与次数", "人均参与次数"],
          data: this.dataSummary.map((item) => item.name),
          bottom: -5,
          left: 60,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "11%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartEffectDetail.map((item) => item.dateTime),
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: seriesList,
        // series: [
        //   {
        //     name: "活动PV",
        //     type: "line",
        //     smooth: true,
        //     areaStyle: {},
        //     color: "#7F85E9",
        //     data: activityPv,
        //   },
        //   {
        //     name: "活动UV",
        //     type: "line",
        //     smooth: true,
        //     areaStyle: {},
        //     color: "#5882FB",
        //     data: activityUv,
        //   },
        //   {
        //     name: "活动中心首页PV",
        //     type: "line",
        //     color: "#FF872F",
        //     areaStyle: {},
        //     smooth: true,
        //     data: pv,
        //   },
        //   {
        //     name: "活动中心首页UV",
        //     type: "line",
        //     color: "#7B61FF",
        //     areaStyle: {},
        //     smooth: true,
        //     data: uv,
        //   },
        //   {
        //     name: "参与人数",
        //     type: "line",
        //     color: "#FFC400",
        //     areaStyle: {},
        //     smooth: true,
        //     data: joinNumber,
        //   },
        //   {
        //     name: "新增人数",
        //     type: "line",
        //     smooth: true,
        //     areaStyle: {},
        //     color: "#FF938E",
        //     data: newAddNumber,
        //   },
        //   {
        //     name: "参与次数",
        //     type: "line",
        //     smooth: true,
        //     areaStyle: {},
        //     color: "#4CDFC0",
        //     data: joinTimes,
        //   },
        //   {
        //     name: "人均参与次数",
        //     type: "line",
        //     smooth: true,
        //     areaStyle: {},
        //     color: "#8693CB",
        //     data: perCapitaTimes,
        //   },
        // ],
      };

      this.myCharts.setOption(option);
    },

    //重置
    queryOne() {
      this.queryForm.evaluateTime = "7";
      this.timeChange(30);
      this.queryTotal();
    },
    //查询我的分组
    handleClick(type) {
      this.tabActiveIndex = 2;
      this.topSelect = type;
      this.queryList();
    },
    handleClick2(type) {
      this.tabActiveIndex = 3;
      this.topSelect = type;
      this.queryList();
    },
    handleClick0(type) {
      this.tabActiveIndex = 1;
      this.topSelect = type;
      this.queryList();
    },
    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    timeChange(type) {
      let self = this;
      let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      console.log(date);
      if (type == null) {
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 7) {
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 15) {
        this.mytime[0] = self.getDay(-15, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-wrap{
  padding: 0px 20px;
  margin-top: 20px;
}
.question_iconOne {
  width: 13px;
  height: 13px;
  display: inline-block;
  line-height: 13px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 4px;
  color: #ccc;
}

.titileDefinition {
  min-width: 1046px;
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  margin: 20px 20px 0 20px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  font-size: 16px;
  color: #2e3458;
  font-weight: bold;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
}

.titClass {
  padding: 36px 24px;
  // margin: 35px;
  margin-top: 10px;
  margin-bottom: 25px;
  background: #fafafa;
  opacity: 1;
  display: flex;
  align-items: center;
  line-height: 22px;
  position: relative;
  .titClassOne {
    margin: 0px 100px 0px 30px;
  }
  .down {
    margin-right: 30px;
  }
  .borderU {
    position: absolute;
    width: 1px;
    height: 110px;
    background: #f3f3f3;
    left: 122px;
  }
}

.section-right-content-box {
  min-width: 1046px;
  border-bottom: 6px;
  padding: 15px 28px 30px 28px;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 20px 20px 20px;
  .tabList {
    display: flex;
    box-sizing: border-box;
    height: 36px;
    line-height: 35px;
    // margin-top: 20px;
    color: #666;
    font-size: 14px;
    margin: 20px 0;
    span {
      margin-right: 3px;
      width: 106px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      vertical-align: middle;
      transform: perspective(1px) translateZ(0);
      box-shadow: 0 0 1px rgba(0, 0, 0, 0);
      border-radius: 2px 2px 0px 0px;
      border: 1px solid #dddddd;
      text-align: center;
    }
    .active {
      position: relative;
      transition: all 0.2s;
      color: #7b61ff;
      border-bottom: none;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        top: 0;
        height: 2px;
        background: #7b61ff;
        border-radius: 6px 6px 0px 0px;
      }
    }
    i {
      flex: 1;
      border-bottom: 1px solid #dddddd;
      margin-left: -3px;
    }
  }
  .b1 {
    width: 98px;
    height: 32px;
    color: #fff;
    border: 1px solid #7b61ff;
    background-color: #7b61ff;
    &:hover {
      opacity: 0.8;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #7b61ff;
      background-color: #7b61ff;
    }
  }
  .background {
    height: 32px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    line-height: 32px;
    padding-left: 12px;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: #7b61ff;
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }

  .overview1 {
    padding: 26px 30px 22px 30px;
    width: 182px;
    height: 100px;
    border-right: 1px solid #f3f3f3;
    opacity: 1;
    margin: 20px 0px;
    .fontClass {
      width: 102px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(102, 102, 102, 1);
      opacity: 1;
    }
    .iconbtn_yiwen {
      color: #cccccc;
      font-size: 13px;
      &:hover {
        color: #7b61ff;
      }
    }
    .question_icon {
      width: 14px;
      height: 14px;
      color: #cccccc;
      display: inline-block;
      line-height: 12px;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #cccccc;
      font-size: 12px;
      font-weight: normal;
    }
    .num {
      width: 65px;
      height: 29px;
      font-size: 24px;
      font-family: DIN;
      font-weight: bold;
      line-height: 29px;
      color: #7b61ff;
      opacity: 1;
      margin-top: 14px;
      margin-bottom: 30px;
    }
  }
  .chart {
    // flex: 1;
    height: 380px;
    min-width: 1000px;
  }
}
</style>
